export default {
  groupName: 'audible',
  appName: 'Audible',
  baseRoute: '/dashboard/audible',
  label: 'Audible Dashboard',
  home: '/slicer',
  image: 'audible.png',
  description: 'Audible Advertising Dashboard'
}
